export const SPINNER_SIZES = {
  LARGE: 80,
  MEDIUM: 60,
  SMALL: 40,
  TINY: 20,
};
